import { defineComponent as I, computed as m, createElementBlock as c, openBlock as i, normalizeClass as M, unref as a, createBlock as n, createCommentVNode as v, Fragment as f, renderList as h } from "vue";
import { useColorMode as j } from "@scalar/use-hooks/useColorMode";
import { useMediaQuery as V } from "@vueuse/core";
import { useRoute as E } from "vue-router";
import { DocumentClasses as _ } from "../../styles.js";
import N from "./HeaderItemGroup.vue.js";
import C from "./HeaderItemLink.vue.js";
import H from "./HeaderItemMeta.vue.js";
import $ from "./HeaderItemSpacer.vue.js";
import B from "./HeaderItemTab.vue.js";
import U from "./HeaderItemVersionSelect.vue.js";
const J = /* @__PURE__ */ I({
  __name: "DocumentHeader",
  props: {
    project: {},
    versions: {},
    activeVersion: {},
    activeUids: {},
    activeGuide: {},
    headerLinks: {},
    isEditable: { type: Boolean },
    resolveInternalLinks: { type: Function }
  },
  emits: ["selectVersion", "navigate", "setSidebar"],
  setup(k, { emit: y }) {
    const s = k, p = y, d = E(), { isDarkMode: b } = j(), g = m(() => b.value ? s.project.logo.darkMode : s.project.logo.lightMode), t = V("(max-width: 1000px)"), L = m(() => {
      const e = [...s.headerLinks];
      return t.value ? e.sort((o) => o.type === "version-selector" ? -1 : 1).filter((o) => o.type !== "spacer") : e;
    });
    function l(e, o) {
      p("navigate", o, e), t.value && p("setSidebar", !1);
    }
    function u(e) {
      var o;
      return (o = s.activeUids) != null && o.includes(e.uid) || e.uid === d.name || e.uid === s.activeGuide || Object.values(d.params).includes(e.uid) ? !0 : e.type === "group" ? e.children.some((r) => u(r)) : !1;
    }
    return (e, o) => (i(), c("header", {
      class: M(["header", a(_).Header])
    }, [
      a(t) ? v("", !0) : (i(), n(H, {
        key: 0,
        logo: g.value,
        primaryVersionUid: e.project.activeVersionId,
        projectName: e.project.name
      }, null, 8, ["logo", "primaryVersionUid", "projectName"])),
      (i(!0), c(f, null, h(L.value, (r) => (i(), c(f, {
        key: r.uid
      }, [
        r.type === "group" ? (i(), n(N, {
          key: 0,
          group: r,
          isEditable: !!e.isEditable,
          isMobile: a(t),
          linkIsActive: u,
          resolveInternalLinks: e.resolveInternalLinks,
          onNavigate: l
        }, null, 8, ["group", "isEditable", "isMobile", "resolveInternalLinks"])) : r.type === "guide" || r.type === "reference" ? (i(), n(B, {
          key: 1,
          isEditable: !!e.isEditable,
          isMobile: a(t),
          linkIsActive: u,
          resolveInternalLinks: e.resolveInternalLinks,
          tab: r,
          onNavigate: l
        }, null, 8, ["isEditable", "isMobile", "resolveInternalLinks", "tab"])) : r.type === "link" ? (i(), n(C, {
          key: 2,
          link: r
        }, null, 8, ["link"])) : r.type === "spacer" ? (i(), n($, { key: 3 })) : r.type === "version-selector" && Object.keys(e.versions).length > 1 ? (i(), n(U, {
          key: 4,
          activeVersion: e.activeVersion,
          versions: e.versions,
          onNavigate: l
        }, null, 8, ["activeVersion", "versions"])) : v("", !0)
      ], 64))), 128))
    ], 2));
  }
});
export {
  J as default
};
